export const adoptCreatedIds = (sent, knownIds, document) => {
  const known = new Set(knownIds.filter(Boolean).map(String))
  const labels = Object.fromEntries(
    (document?.included ?? [])
      .filter(record => record.type === 'website_question')
      .map(record => [String(record.id), String(record.attributes?.label ?? '').trim()])
  )
  const created = (document?.data?.relationships?.website_questions?.data ?? [])
    .map(entry => String(entry.id))
    .filter(id => !known.has(id))
  const fresh = sent.filter(field => !field.id)

  const lineUp =
    fresh.length === created.length && fresh.every((field, index) => labels[created[index]] === field.label.trim())
  if (!lineUp) return false

  fresh.forEach((field, index) => {
    field.id = created[index]
  })
  return true
}
